export const localeLabels = {
  en: "english",
  hi: "hindi",
  mr: "marathi",
  as: "assamese",
  bn: "bengali",
  br: "bodo",
  do: "dogri",
  gu: "gujarati",
  kn: "kannada",
  ks: "kashmiri",
  ko: "konkani",
  mai: "maithili",
  ml: "malayalam",
  mni: "manipuri",
  ne: "nepali",
  or: "odia",
  pa: "punjabi",
  sd: "sindhi",
  ta: "tamil",
  te: "telugu",
} as const;

export const appLocales = Object.keys(localeLabels) as Array<keyof typeof localeLabels>;

export type AppLocale = (typeof appLocales)[number];

export function isAppLocale(value: string): value is AppLocale {
  return appLocales.includes(value as AppLocale);
}
